import { IAvailability } from '../../../models'
import { IFindResultAvailabilities } from '../../../models/find-result-availabilities'
import {
  IFetchEearlierRouteOptionsAction,
  IFetchLaterRouteOptionsAction,
  IFetchReturnRouteOptionsAction,
  IFetchReturnRouteOptionsSuccessfulAction,
  IFetchRouteOptionsAction,
  IFetchRouteOptionsEcorridorAction,
  IFetchRouteOptionsSuccessfulAction,
  IFetchRouteOptionsSuccessfulEcorridorAction,
  ISetAvailabilityAction,
  ISetIsFetchingReturnRouteOptionsAction,
  ISetIsFetchingRouteOptionsAction,
  ISetIsFetchingRouteOptionsEcorridorAction,
  ISetReturnAvailabilityAction,
  RouteOptionStepTypeKeys
} from '../../types'

export function fetchRouteOptionsAction(navigate: boolean, alternatives?: number, onlyToday?: boolean, reservationId?: number): IFetchRouteOptionsAction {
  return { type: RouteOptionStepTypeKeys.FETCH_ROUTE_OPTIONS, payload:{ navigate, alternatives, onlyToday, reservationId} }
}

export function fetchRouteOptionsEcorridorAction(): IFetchRouteOptionsEcorridorAction {
  return { type: RouteOptionStepTypeKeys.FETCH_ROUTE_OPTIONS_ECORRIDOR }
}

export function fetchEarlierRouteOptionsAction(): IFetchEearlierRouteOptionsAction {
  return { type: RouteOptionStepTypeKeys.FETCH_EARLIER_ROUTE_OPTIONS }
}

export function fetchLaterRouteOptionsAction(): IFetchLaterRouteOptionsAction {
  return { type: RouteOptionStepTypeKeys.FETCH_LATER_ROUTE_OPTIONS }
}

export function setIsFetchingRouteOptionsAction(): ISetIsFetchingRouteOptionsAction {
  return { type: RouteOptionStepTypeKeys.FETCHING_ROUTE_OPTIONS }
}

export function setIsFetchingRouteOptionsEcorridorAction(): ISetIsFetchingRouteOptionsEcorridorAction {
  return { type: RouteOptionStepTypeKeys.FETCHING_ROUTE_OPTIONS_ECORRIDOR }
}

export function fetchRouteOptionsSuccessfulAction(options: IFindResultAvailabilities, error: number): IFetchRouteOptionsSuccessfulAction {
  return { type: RouteOptionStepTypeKeys.FETCH_ROUTE_OPTIONS_SUCCESSFUL, payload: options, error: error }
}

export function fetchRouteOptionsSuccessfulEcorridorAction(options: IAvailability[]): IFetchRouteOptionsSuccessfulEcorridorAction {
  return { type: RouteOptionStepTypeKeys.FETCH_ROUTE_OPTIONS_SUCCESSFUL_ECORRIDOR, payload: options }
}

export function setDestinationAvailabilityAction(availabilty: IAvailability): ISetAvailabilityAction {
  return { type: RouteOptionStepTypeKeys.SET_AVAILABILITY, payload: availabilty }
}

export function fetchReturnRouteOptionsAction(navigate: boolean, alternatives?: number, onlyToday?: boolean, reservationId?: number): IFetchReturnRouteOptionsAction {
  return { type: RouteOptionStepTypeKeys.FETCH_RETURN_ROUTE_OPTIONS, payload:{ navigate, alternatives, onlyToday, reservationId} }
}

export function setIsFetchingReturnRouteOptionsAction(): ISetIsFetchingReturnRouteOptionsAction {
  return { type: RouteOptionStepTypeKeys.FETCHING_RETURN_ROUTE_OPTIONS }
}

export function fetchReturnRouteOptionsSuccessfulAction(options: IFindResultAvailabilities, error: number): IFetchReturnRouteOptionsSuccessfulAction {
  return { type: RouteOptionStepTypeKeys.FETCH_RETURN_ROUTE_OPTIONS_SUCCESSFUL, payload: options, error: error }
}

export function setReturnDestinationAvailabilityAction(availabilty?: IAvailability): ISetReturnAvailabilityAction {
  return { type: RouteOptionStepTypeKeys.SET_RETURN_AVAILABILITY, payload: availabilty }
}